export const subtitles = {
    "1": {
        "startTime": 0.0,
        "endTime": 5.5,
        "transcript": "Akluit-llu eru'urqamteki angutet akluit allakartetetullruit aanamta.",
        "translation": "And when we washed their clothes, our mothers had us separate the mens' clothes."
    },
    "2": {
        "startTime": 6.9,
        "endTime": 10.4,
        "transcript": "Wangkuta-llu arnani akluput allakartelluki",
        "translation": "They also had us separate we women's' clothes"
    },
    "3": {
        "startTime": 10.5,
        "endTime": 12.5,
        "transcript": "Tua-i kencikngamegteki.",
        "translation": "Because they were respectfully careful with them."
    },
    "4": {
        "startTime": 13.0,
        "endTime": 18.5,
        "transcript": "Waten man'a ava-i qanrutkurallerci pissuryaraq pitekluku pitullruut.",
        "translation": "As you've said, they did this because of their hunting."
    },
    "5": {
        "startTime": 19.7,
        "endTime": 26.5,
        "transcript": "Arnam aklui allakarmeng iqairumaarkauluteng arnartarrlainaat.",
        "translation": "Women's' clothes would have to be washed separately only with women's clothes."
    },
    "6": {
        "startTime": 27.5,
        "endTime": 34.0,
        "transcript": "Atutullruaqa-llu wiinga. Tua-i atutuaqa tan'gaurlurugarnek-llu irniangqerrama.",
        "translation": "I also used to do that. I do that because I have a lot of male children."
    },
    "7": {
        "startTime": 34.5,
        "endTime": 43.5,
        "transcript": "Tua-i-ll' ukut wani angutem aklui mermun tuavet arnat iqairitellratnun pivkenaki.",
        "translation": "And then, they wouldn't wash the men's clothes in the water where the women's were washed."
    },
    "8": {
        "startTime": 44.5,
        "endTime": 50.4,
        "transcript": "Uum wani nutaan nutaramek emirluki angutem pii piarkautullruut.",
        "translation": "They were supposed to wash men's clothes in new water."
    },
    "9": {
        "startTime": 50.5,
        "endTime": 57.4,
        "transcript": "Ayuqucirtutullruitkut waten ilarqutevkenaki aulukesqelluki qigcikluki.",
        "translation": "The instructed us to take care of them without mixing them like this out of respect."
    },
    "10": {
        "startTime": 57.8,
        "endTime": 62.0,
        "transcript": "Cam iliini aptua, “Ciin waten pivkalarciki?”",
        "translation": "One day, I asked, “Why do you have them do this?”"
    },
    "11": {
        "startTime": 62.5,
        "endTime": 66.0,
        "transcript": "Aanamnun aptetullruunga nallukemnek.",
        "translation": "I used to ask my mother about things I didn't know."
    },
    "12": {
        "startTime": 66.5,
        "endTime": 68.8,
        "transcript": "Tua-ll' waten aanama pianga:",
        "translation": "And then my mother said this to me:"
    },
    "13": {
        "startTime": 69.0,
        "endTime": 73.7,
        "transcript": "Waten-gguq ava-i qanrutkurallerpecicetun wanirpak",
        "translation": "She said, as youpl just did now"
    },
    "14": {
        "startTime": 73.8,
        "endTime": 80.0,
        "transcript": "Pissullerkaat, pitengnaqlerkaat yuilqumek pitekluku tuaten pimaut makut.",
        "translation": "They are [washed] like this because of their hunting, because of their subsistence in the wilderness."
    },
    "15": {
        "startTime": 80.5,
        "endTime": 86.8,
        "transcript": "Taringellemnek maa-i qaneryuglua qanertua sassairutqatalliniamegnuk.",
        "translation": "I wanted to talk about what I understood because we're2 running out of time."
    },
    "16": {
        "startTime": 87.0,
        "endTime": 93.5,
        "transcript": "Tua-i-llu wangkuta cali arnani neqnek aulukilriani",
        "translation": "And then we women who take care of food"
    },
    "17": {
        "startTime": 94.0,
        "endTime": 104.5,
        "transcript": "Tua-i qigcikluki angutet unangkengait melqulgungraata caungraata tua-i angutet unakellrit qigcikluki aulukellruaput.",
        "translation": "We respected what the men caught, animals with fur, no matter what they were, took care of what the men caught out of respect."
    },
    "18": {
        "startTime": 106.0,
        "endTime": 110.0,
        "transcript": "Tamana tua-i alerquun atungnaqu'urluku.",
        "translation": "We tried to adhere to that instruction."
    },
    "19": {
        "startTime": 110.9,
        "endTime": 114.0,
        "transcript": "Uqlaulluki pillrunritaput.",
        "translation": "We didn't pollute nature with them."
    },
    "20": {
        "startTime": 114.3,
        "endTime": 124.0,
        "transcript": "Pitaita enrit, carrluit, iluita-llu carrillrit uqlaulluki aulukellrunritaput.",
        "translation": "We didn't take care of them to pollute nature with the bones, scraps, or guts of what they caught."
    },
    "21": {
        "startTime": 125.0,
        "endTime": 137.5,
        "transcript": "Ca tamalkuan apyutektullruaqa aanamnun. Ilarugailama apyutektullruanka.",
        "translation": "I asked my mother about everything. I asked about them because I didn't have a lot of relatives."
    },
    "22": {
        "startTime": 137.6,
        "endTime": 140.5,
        "transcript": "Tua-ll' waten pitullruanga:",
        "translation": "And then she would say this to me:"
    },
    "23": {
        "startTime": 141.5,
        "endTime": 154.4,
        "transcript": "“Ava-i uqlaupakaqumki-gguq tamakut pitai uum aiparma, tauna-gguq nakriaruciiquq, yuilqumek-llu pitqerciigalilunii.”",
        "translation": "“If I pollute nature with what my spouse catches, he will become a bad hunter, and he will not catch anything from the wilderness.”"
    },
    "24": {
        "startTime": 154.5,
        "endTime": 165.5,
        "transcript": "Tua-i-gguq-wa uqlaulluki wiinga tuaten tua-i piciqellrii uqlauskumki, pitarkam pinrirluku.",
        "translation": "She said that if I pollute nature with them, that will happen, animals will no longer come to him."
    },
    "25": {
        "startTime": 166.0,
        "endTime": 173.5,
        "transcript": "Tua-i-ll' ukvekluki wiinga. Ukvektullruluki tamakut tuaten pitullinillrat.",
        "translation": "And I believed them. I believed that that would happen to them."
    },
    "26": {
        "startTime": 174.0,
        "endTime": 190.4,
        "transcript": "Cali-llu ava-i qanellruunga pingnaquralput arnani uitaurayuilamta, yuilqumek pingnaquratuamta piyararrarluta-llu pitullruluta.",
        "translation": "I also just talked about we women's subsistence because we weren't sedentary, we also had gathering spots in the wilderness because we subsisted."
    },
    "27": {
        "startTime": 190.9,
        "endTime": 201.0,
        "transcript": "Qigcikluku yuum pivianun, yuum piyaraanun pisqumamayuitellruukut",
        "translation": "They told us not to go to people's gathering spots out of respect"
    },
    "28": {
        "startTime": 201.1,
        "endTime": 209.0,
        "transcript": "Taum-wa yuum tauna piyaraqngaku qigcignaqluni umyugaa nall'artenritlerkaa.",
        "translation": "We should show respect for that person's gathering spot in case they would be offended."
    },
    "29": {
        "startTime": 210.3,
        "endTime": 217.0,
        "transcript": "Tua-i pivimteńun tau͡gaam wangkuta pingnaquratullruukut piciatun pivkenata.",
        "translation": "We tried to go to our own gathering spots, not random places."
    },
    "30": {
        "startTime": 218.0,
        "endTime": 224.5,
        "transcript": "Tua-i-llu cali niitetullrulria qalartellrianek",
        "translation": "I also used to hear people talk"
    },
    "31": {
        "startTime": 225.0,
        "endTime": 241.4,
        "transcript": "Angutet-gguq makut pissurtet pissulriim canek aruarkanek tuani-llu taluyam nuniini kuvyam-llu nuniini aruarkanek piyuitut.",
        "translation": "They said that they wouldn't put what hunters caught where they would spoil around that fish trap or drift net area."
    },
    "32": {
        "startTime": 246.5,
        "endTime": 259.0,
        "transcript": "Tauna-gguq kuvyiryaraq neqem aruvikellrukani allrakuani nurciarkauguq neqmek.",
        "translation": "They said that if food spoils aroudn that drift net area, fish will be short the next year."
    },
    "33": {
        "startTime": 259.8,
        "endTime": 263.0,
        "transcript": "Pitangqerrngaunani tuaten amllertalriamek.",
        "translation": "It would have as much [as it usually does]."
    },
    "34": {
        "startTime": 263.5,
        "endTime": 270.0,
        "transcript": "Tauna-llu cali taluyaq pissuun kuicuarmi tuani civingalria",
        "translation": "And that fish trap that is set in that creek"
    },
    "35": {
        "startTime": 270.1,
        "endTime": 280.0,
        "transcript": "Kuicuar-gguq tamana cali pissurvikestiin kencikaa. Aruiviksuumiitaa elliin pissuryaraqngamiu.",
        "translation": "They said the fisher respectfully watches over that creek. He doesn't want anything to spoil there because he fishes there."
    },
    "36": {
        "startTime": 281.5,
        "endTime": 288.0,
        "transcript": "Aruivikumallrukuni-gguq ungungssimek camek tua-i pitamek taluyat nuniit",
        "translation": "They said that if any animal spoils there around that fish trap"
    },
    "37": {
        "startTime": 288.8,
        "endTime": 294.0,
        "transcript": "Allamiani nakerrluni cali pitangqerrngaituq pissulallratun.",
        "translation": "It would have as much fish as it used to catch the next year."
    },
    "38": {
        "startTime": 294.5,
        "endTime": 300.0,
        "transcript": "Tamakut tang wangkuta asgurakellrunrilkeput avani ciuqvaarni.",
        "translation": "You see, we didn't doubt those back then."
    },
    "39": {
        "startTime": 300.5,
        "endTime": 307.4,
        "transcript": "Ca tamalkuan au͡gkut yuut qigcikellruat yuilqurrungraan nunaungraan-llu.",
        "translation": "The people back then respected everything, even the wilderness and land."
    },
    "40": {
        "startTime": 307.5,
        "endTime": 315.0,
        "transcript": "Ava-i qanllemtun watua nunam qainga tangniirupailgan",
        "translation": "As I just said, before the land became an eyesore"
    },
    "41": {
        "startTime": 315.1,
        "endTime": 322.4,
        "transcript": "Makunek kalikallernek can-allernek-llu patuvailgan nunam qainga menuitellruuq",
        "translation": "The land used to be pristine before it was covered with these paper products and cans"
    },
    "42": {
        "startTime": 322.5,
        "endTime": 327.8,
        "transcript": "Nunat-llu nuniit elaqvanun assirluni tangerrnarqetullruuq.",
        "translation": "And areas far out from villages looked good."
    },
    "43": {
        "startTime": 328.0,
        "endTime": 335.5,
        "transcript": "Mat'um nalliini yuum tekiartellra tamarmi elitaqnarqelartuq.",
        "translation": "These days, you can tell every place a person has come to."
    },
    "44": {
        "startTime": 336.4,
        "endTime": 345.8,
        "transcript": "Una yuum tekitellrullinikii canek-llu egqaqilliniluni maa-i cat cautellminek atullminek.",
        "translation": "A person would come upon this place and throw things away, his old things and things he's used."
    },
    "45": {
        "startTime": 346.0,
        "endTime": 349.0,
        "transcript": "Mat'um nalliini tuaten nuna ellirtuq.",
        "translation": "These days, that's what the land has become."
    },
    "46": {
        "startTime": 349.5,
        "endTime": 352.8,
        "transcript": "Menuitenrirtuq yuilqurtuumarmi.",
        "translation": "Even the wilderness is no longer pristine."
    },
    "47": {
        "startTime": 353.0,
        "endTime": 355.0,
        "transcript": "Qigcikenriryugnarqaat.",
        "translation": "I don't think they respect it anymore."
    },
    "48": {
        "startTime": 358.2,
        "endTime": 361.0,
        "transcript": "Tua-i tuaten taktaaqa. [Okay.]",
        "translation": "That's all from me. [Okay.]"
    },
    "49": {
        "startTime": 362.8,
        "endTime": 364.0,
        "transcript": "She says that…",
        "translation": "She says that…"
    },
    "50": {
        "startTime": 365.0,
        "endTime": 376.7,
        "transcript": "Naunraat, kuiget, nanvat-llu, tamakut qigcik'lallrukci tamaani.",
        "translation": "Youpl respected plants, rivers, lakes, those things back then."
    },
    "51": {
        "startTime": 376.8,
        "endTime": 380.4,
        "transcript": "Kencikluki qigcikluki. [Yaa, yaa.]",
        "translation": "Respectfully watched over them and respected them. [Yes, yes.]"
    },
    "52": {
        "startTime": 385.4,
        "endTime": 394.0,
        "transcript": "Au͡gkut mat'umi-llu kuigpagmi maani Kusquqvagmi tayima Yukon-ami-llu piciquq",
        "translation": "Those things even here in this great Kuskokwim River, probably on the Yukon too"
    },
    "53": {
        "startTime": 394.5,
        "endTime": 402.5,
        "transcript": "Yuut alerquutengqertut kuigmek mat'umek kencikluku piklerkaanek.",
        "translation": "People are instructed to respectfully watch over this river."
    },
    "54": {
        "startTime": 403.5,
        "endTime": 415.0,
        "transcript": "Tua-i-gguq cali wangkutni up'nerkami wall'u kiagmi-llu",
        "translation": "Also, for us, in the spring or summer"
    },
    "55": {
        "startTime": 415.8,
        "endTime": 419.4,
        "transcript": "Imkunek au͡gkunek ciuliamteńek alerquutengqertukut",
        "translation": "We have instructions from our ancestors"
    },
    "56": {
        "startTime": 419.5,
        "endTime": 432.0,
        "transcript": "Mat'umun kuigmun kiagaqan kiagtetarnek allragnillarnek neqlernek egcivikesqevkenaku watqapik.",
        "translation": "In the summer, we should never throw old food from the last summer or year."
    },
    "57": {
        "startTime": 432.1,
        "endTime": 443.7,
        "transcript": "Tua-i-gguq tamakut kiagtetaat tamaani pilallrata tamana neqem nayussiyaagngaitaa",
        "translation": "They said that if those year-old [foods] go there, the fish won't go around it too often"
    },
    "58": {
        "startTime": 444.0,
        "endTime": 454.7,
        "transcript": "Tua-i imkucetun kuiggaarcetun uum qanrutkellracetun tamana taum nunii neqengqerrngaunani elluarrluni.",
        "translation": "Like that creek that she talked about, it won't have a healthy amount of fish around there."
    },
    "59": {
        "startTime": 455.5,
        "endTime": 462.0,
        "transcript": "Tau͡gaam-gguq kiagtetaat tamakut egtevkenaki mermun tamaavet.",
        "translation": "Instead, they said not to throw those year-old [foods] into that water."
    },
    "60": {
        "startTime": 463.0,
        "endTime": 469.0,
        "transcript": "Elagluku-gguq nuna teq'aqilaput tamaavet alaicetevkenaki-llu.",
        "translation": "They said we should bury them in pits so that they're not noticeable."
    },
    "61": {
        "startTime": 469.5,
        "endTime": 479.9,
        "transcript": "Tau͡gaam-gguq makut tua-i nutarat neqet iluit qiluit-llu egtengramteki",
        "translation": "But they said we could throw fresh fish along with their guts"
    },
    "62": {
        "startTime": 480.0,
        "endTime": 493.0,
        "transcript": "Unavet tau͡gaam tutmararkaunrilngurmun kuvesqelluki yuum tutmarngailkiitnun, etuuralriamun, entaanrilngurmun-llu.",
        "translation": "We should only dump them down where no one will tread, where no person will tread, somewhere deep where the tide does not go out too much."
    },
    "63": {
        "startTime": 493.5,
        "endTime": 505.0,
        "transcript": "Tua-i-am maa-i egciyaurtut mer'em ceńaq tua-i man'a neqngurrluku tamakunek alerquuteseng maligtaqunrilamegteggu maa-i.",
        "translation": "They've started throwing them away these days until the shore has been covered in food because they don't adhere to their instruction."
    },
    "64": {
        "startTime": 505.8,
        "endTime": 516.5,
        "transcript": "Tua-i cali tuaten kuigem mat'um un'um kuigpallraam kencikluku atullerkaa tuaten ayuquq wangkutnun.",
        "translation": "That is what respectfully watching over this great river when we subsist from it is supposed to be for us."
    },
    "65": {
        "startTime": 519.8,
        "endTime": 529.8,
        "transcript": "Okay, as far as the river's, in spring or summer, the rules of their forefathers were that they were told not to throw",
        "translation": "Okay, as far as the river's, in spring or summer, the rules of their forefathers were that they were told not to throw"
    },
    "66": {
        "startTime": 530.0,
        "endTime": 541.5,
        "transcript": "If there should be leftovers that can't be eaten from the winter, that you do not throw these into the river.",
        "translation": "If there should be leftovers that can't be eaten from the winter, that you do not throw these into the river."
    },
    "67": {
        "startTime": 542.5,
        "endTime": 548.0,
        "transcript": "If you do, there's a chance that the new fish will not come to that river.",
        "translation": "If you do, there's a chance that the new fish will not come to that river."
    },
    "68": {
        "startTime": 551.5,
        "endTime": 561.0,
        "transcript": "Au͡gna, au͡gna wani taringecurlagnayukluku nallulriarulaata makut, una-llu wani yaquleyagiurteńek pilria.",
        "translation": "In case what was just said may be understood because these people do not know, including this Fish and Game officer."
    },
    "69": {
        "startTime": 563.0,
        "endTime": 571.5,
        "transcript": "Neqnek wangkuta egcisciigatukut, yugmek-llu egcilriamek niiteksaitua man'a engelkarrluku.",
        "translation": "We cannot throw food away, and I have not heard of anyone throwing food away to this day."
    },
    "70": {
        "startTime": 571.8,
        "endTime": 577.0,
        "transcript": "Tau͡gaam ellaita ukut qatellriaput neqnek egqaqilartut.",
        "translation": "Our Caucasian counterparts, however, throw food away."
    },
    "71": {
        "startTime": 577.3,
        "endTime": 578.3,
        "transcript": "Tua-i.",
        "translation": "That's all."
    },
    "72": {
        "startTime": 583.5,
        "endTime": 590.0,
        "transcript": "He didn't want any misunderstanding of throwing away.",
        "translation": "He didn't want any misunderstanding of throwing away."
    },
    "73": {
        "startTime": 590.5,
        "endTime": 600.0,
        "transcript": "He's saying that the native people as a whole are told that you don't throw away food.",
        "translation": "He's saying that the native people as a whole are told that you don't throw away food."
    },
    "74": {
        "startTime": 601.5,
        "endTime": 607.0,
        "transcript": "He just wanted to make that clear because he doesn't say that they do that.",
        "translation": "He just wanted to make that clear because he doesn't say that they do that."
    },
    "75": {
        "startTime": 609.9,
        "endTime": 617.9,
        "transcript": "But he has seen, you know, people, you know, who don't have that kind of rule",
        "translation": "But he has seen, you know, people, you know, who don't have that kind of rule"
    },
    "76": {
        "startTime": 618.5,
        "endTime": 623.0,
        "transcript": "Throwing fish away just the way the are.",
        "translation": "Throwing fish away just the way the are."
    },
    "77": {
        "startTime": 627.0,
        "endTime": 632.0,
        "transcript": "Icigg' qigcik'kuvgu-gguq ca imna neqngungraan",
        "translation": "You know, she asked if you respect something, even fish"
    },
    "78": {
        "startTime": 632.5,
        "endTime": 643.4,
        "transcript": "Qaill'-gguq-qaa icigg' cut-atullruaci qigciklerpeci pitaciatun?",
        "translation": "You know, would youpl cut them a certain way out of respect?"
    },
    "79": {
        "startTime": 643.5,
        "endTime": 649.0,
        "transcript": "Wall'u-gguq-qaa tauna piciatun kepuryuumauq neqa?",
        "translation": "Or, can that fish be cut in any way?"
    },
    "80": {
        "startTime": 649.9,
        "endTime": 659.5,
        "transcript": "Makut tamaa neqet wangkutnun cali inerquutekumallruut imumi, tayima-wa tua-i unani-ll' imarpigmiutaat pillilriit.",
        "translation": "We had admonishments surrounding these fish back then, and they probably had them with marine animals down on the coast."
    },
    "81": {
        "startTime": 660.0,
        "endTime": 670.8,
        "transcript": "Neqet wangkuta piqertuutamek aturluta kepuusqevkenaki, tau͡gaam uluamek aturluta kepluki uruumakata.",
        "translation": "They told us not to cut fish with axes, but with knifes if they're thawed."
    },
    "82": {
        "startTime": 670.9,
        "endTime": 675.4,
        "transcript": "Tamaa-i tamat tamakutgun tau͡gaam pisqelluki.",
        "translation": "They told us to only use those [knives] on everything."
    },
    "83": {
        "startTime": 675.5,
        "endTime": 683.0,
        "transcript": "Inerquutauluteng piqertuutaq aturluku neqnun taukunun pisqevkenata.",
        "translation": "They admonished us against using axes on those fish."
    },
    "84": {
        "startTime": 684.0,
        "endTime": 689.5,
        "transcript": "Kumlaskata tau͡gaam ner'arkaukatki qimugtet maani tagumarilriit",
        "translation": "Only when they're frozen and the dogs inland will eat them"
    },
    "85": {
        "startTime": 690.0,
        "endTime": 696.0,
        "transcript": "Kuigmi cali piqertuarluki inerquutekluki neqa tauna unani wall' akulmi.",
        "translation": "They admonished us against using axes on that fish down by the water or inland."
    },
    "86": {
        "startTime": 696.5,
        "endTime": 704.0,
        "transcript": "Nugumalria piqertuutarmek kepuusqevkenaku inerquutnguluni tua-i tamana.",
        "translation": "That was an admonishment, not to cut fish out of the water with axes."
    },
    "87": {
        "startTime": 704.5,
        "endTime": 713.5,
        "transcript": "Tua-i tuaten au͡gna ayuquq. Piqertuutaq atuusqumavkenani akulmi wall' maani-llu.",
        "translation": "That's what it's like. They told us not to use axes inland or down by the water."
    },
    "88": {
        "startTime": 714.4,
        "endTime": 718.4,
        "transcript": "Tua-i piqertuarluku tamana cali assikevkenaku.",
        "translation": "They didn't like when axes were used on those."
    },
    "89": {
        "startTime": 718.5,
        "endTime": 722.5,
        "transcript": "Kelgalarniluki cali neqairut'larniluki tuaten",
        "translation": "They also said that they [inform others] and that no more fish go there"
    },
    "90": {
        "startTime": 723.5,
        "endTime": 730.2,
        "transcript": "Aulukestemta tangvagaqamikut picuvvlagluta tuaten pillrit tamakut neqet.",
        "translation": "When our caretaker watched us taking bad care of those fish."
    },
    "91": {
        "startTime": 731.0,
        "endTime": 732.9,
        "transcript": "Yaa, he has that answer. Quyana cakneq tailuci.",
        "translation": "Yes, he has that answer. Thank you so much for coming."
    },
    "92": {
        "startTime": 732.9,
        "endTime": 733.5,
        "transcript": "Yaa, he has that answer.",
        "translation": "Yes, he has that answer."
    },
    "93": {
        "startTime": 734.0,
        "endTime": 737.0,
        "transcript": "Elisa, piqertuarluki?",
        "translation": "Elisa, what is “piqertuarluki?”"
    },
    "94": {
        "startTime": 738.0,
        "endTime": 738.8,
        "transcript": "Axe.",
        "translation": "Axe."
    },
    "95": {
        "startTime": 739.0,
        "endTime": 749.0,
        "transcript": "Okay, okay. There's a way that you cut rather than hitting, hitting motion like an axe or what",
        "translation": "Okay, okay. There's a way that you cut rather than hitting, hitting motion like an axe or what"
    },
    "96": {
        "startTime": 749.5,
        "endTime": 757.0,
        "transcript": "Unless they're frozen and can't be cut any other way, then you show respect if it's thawed.",
        "translation": "Unless they're frozen and can't be cut any other way, then you show respect if it's thawed."
    },
    "97": {
        "startTime": 758.8,
        "endTime": 763.0,
        "transcript": "Neqerrluaraat, neqerrluarnek pilaqeput tua-i dry fish.",
        "translation": "Dried fish, we call dried fish neqerrluaraat."
    },
    "98": {
        "startTime": 763.8,
        "endTime": 768.5,
        "transcript": "Leftover-aarqamta qimugtellegnun tua-i tuntuaput.",
        "translation": "When we have leftovers, we give them to those who have dogs."
    },
    "99": {
        "startTime": 769.3,
        "endTime": 774.0,
        "transcript": "Taumun qimugtelilriamun yugmun tua-i tunluki cikiutekluki.",
        "translation": "We give them as gifts to those who have a lot of dogs."
    },
    "100": {
        "startTime": 774.2,
        "endTime": 779.4,
        "transcript": "And he also wanted to say that if they have leftover, like…",
        "translation": "And he also wanted to say that if they have leftover, like…"
    },
    "101": {
        "startTime": 780.4,
        "endTime": 785.0,
        "transcript": "…cat-wa ayuqenrilnguut naunraat.",
        "translation": "…different kinds of plants."
    },
    "102": {
        "startTime": 785.5,
        "endTime": 798.5,
        "transcript": "Au͡gkut-llu berries-aat tua-i-w' unitetuaput iqvasqenrilkeput tau͡gaam atsalingraan, you know, tegumanrilnguut.",
        "translation": "We also leave those berries that we don't want picked, but even if there are a lot of berries, you know, that aren't taken."
    },
    "103": {
        "startTime": 799.0,
        "endTime": 810.0,
        "transcript": "Tau͡gaam uniciaqameng aqvaarkauluki atsat piyualuni pillrukuni pavani atmagluki.",
        "translation": "But when they leave berries, they would get them with knapsacks if they walked inland."
    },
    "104": {
        "startTime": 810.8,
        "endTime": 821.5,
        "transcript": "Unangliqkuni tua-i uniciqerluni natmun tuavet piarkaunrilngurmun nutaan aqvaluki taukut atsat.",
        "translation": "If [s]he picks a lot, [s]he will leave them where they won't be picked and then go get those berries."
    },
    "105": {
        "startTime": 822.3,
        "endTime": 830.5,
        "transcript": "Wall'u yuk ikayungqerquni tua-i unicivkenani piarkauluku.",
        "translation": "Or if a person has help, [s]he will not leave [berries]."
    },
    "106": {
        "startTime": 831.0,
        "endTime": 839.8,
        "transcript": "Cali atsaungraata tamaani-am yuilqumi amllengraata pitsaqutmek tutmarluki pisqevkenaki",
        "translation": "And even if there are a lot of berries in the wilderness, they said not to purposefully tread on them"
    },
    "107": {
        "startTime": 840.0,
        "endTime": 843.5,
        "transcript": "Makut salmonberries-aat, tan'gerpiit.",
        "translation": "These cloudberries, crowberries."
    },
    "108": {
        "startTime": 843.8,
        "endTime": 846.8,
        "transcript": "Tau͡gaam amlliurluki avitaalriacetun.",
        "translation": "Instead, they should keep from stepping on them."
    },
    "109": {
        "startTime": 846.9,
        "endTime": 851.8,
        "transcript": "Tua-i ilii pinritsaange'rmi amllessiyaagqameng tutmalaraput.",
        "translation": "Sometimes, though we try not to, we tread on them when there is too much."
    },
    "110": {
        "startTime": 852.0,
        "endTime": 871.5,
        "transcript": "Cali imkut naunraat nertukput wangkuta, quagcit, quagcit, angukaat-llu, napat-llu akuliitni atsat",
        "translation": "And those plants that we eat, sourdock, sourdock, and wild rhubarb, and berries among trees"
    },
    "111": {
        "startTime": 871.6,
        "endTime": 881.0,
        "transcript": "Tamaa-i cali nallullikci ilait mercuullugpiit, agautaat, atsaanglluut",
        "translation": "Youpl probably don't know about some of them [like] high-bush cranberries, red currants, black currants"
    },
    "112": {
        "startTime": 881.4,
        "endTime": 885.5,
        "transcript": "Tua-i cali tamaa-i tamakut iqvatukeput napat iluatnek.",
        "translation": "And those berries we pick among trees."
    },
    "113": {
        "startTime": 886.5,
        "endTime": 890.0,
        "transcript": "Tau͡gaam inerquutnguluteng-am ilait.",
        "translation": "But some are admonished against."
    },
    "114": {
        "startTime": 890.5,
        "endTime": 895.5,
        "transcript": "Nallullikten tayima tulukaruut atsaitnek neqaitnek",
        "translation": "You probably don't know about baneberries that ravens eat"
    },
    "115": {
        "startTime": 896.0,
        "endTime": 901.5,
        "transcript": "Waten tua-i plant-aq atsarugarnek nevumaluni waten kavirpak.",
        "translation": "A plant with a lot of berries sticking on it that's all red."
    },
    "116": {
        "startTime": 902.3,
        "endTime": 904.5,
        "transcript": "Tua-i-gguq tulukaruut neqait.",
        "translation": "They call those baneberries."
    },
    "117": {
        "startTime": 904.8,
        "endTime": 908.5,
        "transcript": "Nerkumteki tamakut naulluqertarkauluta.",
        "translation": "If we eat them, we'll get sick."
    },
    "118": {
        "startTime": 909.4,
        "endTime": 921.5,
        "transcript": "Cali yuilqumi imkut inerquutnguluteng neresqevkenaki kanaqliit neqait. Uquutvaguanek-wa pilaqeput.",
        "translation": "They also admonish us against eating those things muskrats eat in the wilderness. We call them poison water hemlocks."
    },
    "119": {
        "startTime": 922.0,
        "endTime": 926.0,
        "transcript": "Tuqunaqluteng tua-i poison-aaruluteng tua-i tamakut.",
        "translation": "Those are deadly and poisonous."
    },
    "120": {
        "startTime": 927.5,
        "endTime": 935.5,
        "transcript": "Cali tua-i tamaa-i tamakut mulngakluki irniamteńun apertualuki assiiluciat.",
        "translation": "We should also be wary and tell our children that they're bad."
    },
    "121": {
        "startTime": 936.5,
        "endTime": 942.0,
        "transcript": "Cat-llu tua-i tamakut naunraat neryunarqellriit cali apertualuki.",
        "translation": "We should also tell our children about those edible plants."
    },
    "122": {
        "startTime": 945.0,
        "endTime": 949.0,
        "transcript": "Ikiituut tuaten tamakut tamaa-i nertukput.",
        "translation": "We also eat those wild celery."
    },
    "123": {
        "startTime": 949.5,
        "endTime": 960.0,
        "transcript": "Cuassaaryaraput-llu makut Kass'at apqaitnek spinich, tua-i allakarmeng-am nunamek teguyarauluteng",
        "translation": "Our greens that they call spinich in English are gathered separately from the land"
    },
    "124": {
        "startTime": 960.5,
        "endTime": 964.0,
        "transcript": "Ciilqaat tuaten tamaa-i tamakut.",
        "translation": "Including those fireweed."
    },
    "125": {
        "startTime": 965.0,
        "endTime": 975.9,
        "transcript": "Makut-llu napat cuyait naugaararqata cali imkut tegg'ivailgata nerluki.",
        "translation": "And when these tree leaves are newly grown, eat them before they harden."
    },
    "126": {
        "startTime": 976.0,
        "endTime": 983.0,
        "transcript": "Tua-i unatminek cayugluni nerluki, tua-i egmian tamualuki nerluki imkut.",
        "translation": "Pull them with your hand and eat them, chew and eat them right away."
    },
    "127": {
        "startTime": 984.9,
        "endTime": 988.5,
        "transcript": "Tamakut assirluteng naugaararqameng.",
        "translation": "Those are good when they're newly grown."
    },
    "128": {
        "startTime": 988.6,
        "endTime": 992.0,
        "transcript": "Tua-i tamakut nertukput naunraat tamakut.",
        "translation": "Those are the plants that we eat."
    },
    "129": {
        "startTime": 992.5,
        "endTime": 999.0,
        "transcript": "Ilait-wa tua-i nallunrilketen cat tua-i naunraat. Nallunritlikten cat.",
        "translation": "You probably know some of the plants. You probably know some."
    },
    "130": {
        "startTime": 1002.9,
        "endTime": 1007.0,
        "transcript": "Imkut wiinga nalluanka ilait.",
        "translation": "I don't know some of them."
    },
    "131": {
        "startTime": 1008.0,
        "endTime": 1016.0,
        "transcript": "Makut tang tua-i imkut, imkut waterlily-nek pitukait Yugtun im' caulriit?",
        "translation": "Those things they call waterlilies, what are they in Yup'ik again?"
    },
    "132": {
        "startTime": 1018.9,
        "endTime": 1022.0,
        "transcript": "Wiinga-w' au͡gna qitevtellren taringenrilkeka.",
        "translation": "I didn't understand what you said in English."
    },
    "133": {
        "startTime": 1023.8,
        "endTime": 1029.5,
        "transcript": "Imkut nauw' cuyarpalget nanvani kuiguani-llu pugtalriit?",
        "translation": "Those ones with big leaves floating in lakes and oxbow lakes?"
    },
    "134": {
        "startTime": 1029.5,
        "endTime": 1034.9,
        "transcript": "Imkut-qaa? Canek ima tanem pitukait?",
        "translation": "Those? What do they call them again?"
    },
    "135": {
        "startTime": 1035.0,
        "endTime": 1038.0,
        "transcript": "Nallunaicaaquq-am atra. (Nallunricaaqaqa.)",
        "translation": "Its name is obvious. (I do know it.)"
    },
    "136": {
        "startTime": 1038.1,
        "endTime": 1039.0,
        "transcript": "Paparnat pilliut?",
        "translation": "Do you mean paparnat?"
    },
    "137": {
        "startTime": 1039.1,
        "endTime": 1040.0,
        "transcript": "Paparnat.",
        "translation": "Yellow pond lilies."
    },
    "138": {
        "startTime": 1040.8,
        "endTime": 1044.8,
        "transcript": "Tua-i tang tamakut atutaciit nallukenka.",
        "translation": "I don't know how useful those are."
    },
    "139": {
        "startTime": 1044.9,
        "endTime": 1046.9,
        "transcript": "Wii-ll' nalluanka.",
        "translation": "I don't know either."
    },
    "140": {
        "startTime": 1047.0,
        "endTime": 1052.0,
        "transcript": "Tua-i au͡gkut ava-i waten ilait umyuaqekenka qanrutkanka plant-at.",
        "translation": "I talked about some of those plants I thought of."
    },
    "141": {
        "startTime": 1052.1,
        "endTime": 1054.4,
        "transcript": "Ilaqerciqan au͡gna qanellra?",
        "translation": "Will you add to what he said?"
    },
    "142": {
        "startTime": 1054.5,
        "endTime": 1056.5,
        "transcript": "Carrarmek ilaqaqerlaku. (Ii-i.)",
        "translation": "Let me add a little. (Okay.)"
    },
    "143": {
        "startTime": 1057.0,
        "endTime": 1067.5,
        "transcript": "Tua-i-wa ava-i makut-llu naunraat ilakekai uum kalikam uum iluanelnguum naunraat-llu tua-i makut pillerkait.",
        "translation": "These plants are included in those paper and what to do with plants."
    },
    "144": {
        "startTime": 1067.6,
        "endTime": 1077.5,
        "transcript": "Makut-llu cat tua-i anagulluki uitaarkauluki cumerrnarqellrunritut wangkuta nallemteńi.",
        "translation": "These things that were not excessively abundant were not easily gathered in our time."
    },
    "145": {
        "startTime": 1078.0,
        "endTime": 1087.0,
        "transcript": "Caanguaruarkaq tua-i caanguaruarkaukan amllessiyaakuni caanguaruciqngami ilii unakellemta.",
        "translation": "Some of what we gathered would be wasted if [we gathered] too much that would eventually be wasted."
    },
    "146": {
        "startTime": 1088.5,
        "endTime": 1099.0,
        "transcript": "Tau͡gaam tua-i engelqerrluta cumercetetullruitkut tua-i egtarkaunrilngurmek nang'arkamteńek",
        "translation": "Instead, they would have us gather according to what we needed so that we would not throw them away but finish them."
    },
    "147": {
        "startTime": 1099.5,
        "endTime": 1103.0,
        "transcript": "Yuilquq-wa tua-i qigcikngamegteggu yuut imkut",
        "translation": "Because the people back then respected the wilderness"
    },
    "148": {
        "startTime": 1104.0,
        "endTime": 1109.5,
        "transcript": "Cat-llu piyarameng nunait tua-i ava-i qanllemtun qigcikngamegteggu.",
        "translation": "And they respected their gathering grounds as they said."
    },
    "149": {
        "startTime": 1110.5,
        "endTime": 1118.5,
        "transcript": "Amlleriluku ca ciptarkauluku pivakaasqessuitellruat wangkutnun.",
        "translation": "They didn't have us gather too much exceeding what we needed."
    },
    "150": {
        "startTime": 1119.0,
        "endTime": 1123.0,
        "transcript": "Tegussiyaagesqessuitellruat ciptarkauluku.",
        "translation": "They told us not to gather more than we needed."
    },
    "151": {
        "startTime": 1124.5,
        "endTime": 1129.5,
        "transcript": "Tua-i-w' alinguqelriatun piluku yuilquq yuilqurrungraan.",
        "translation": "It was like they feared the wilderness even if it was just the wilderness."
    },
    "152": {
        "startTime": 1129.6,
        "endTime": 1134.0,
        "transcript": "Cat-llu nauyaraata nunaita alinguqellriatun-wa tua-i.",
        "translation": "And it was like they feared the places where things grew."
    },
    "153": {
        "startTime": 1136.0,
        "endTime": 1145.5,
        "transcript": "Amllermek, amllerpagmek ciptarkamek avurcecuitellruitkut aanamta wangkuta.",
        "translation": "Our mothers wouldn't let us gather a whole lot more than we needed."
    },
    "154": {
        "startTime": 1145.6,
        "endTime": 1148.5,
        "transcript": "Ellait-llu-wa tua-i pitullrullilriit.",
        "translation": "They probably also did that."
    },
    "155": {
        "startTime": 1149.0,
        "endTime": 1166.4,
        "transcript": "Tau͡gken-am makut ilait naunraat cali amlleriluki piaqamteki kenirarkat, kenirluki piarkaput au͡gkut-llu quagcit wall' angukaat",
        "translation": "However, when we gathered a lot of some of these plants that we would cook, the ones we would cook, sourdock or wild rhubarb"
    },
    "156": {
        "startTime": 1166.5,
        "endTime": 1176.0,
        "transcript": "Tua-i tamakut tau͡gaam tua-i wiinga kiingita kenirluki amlleriluki pit'laraput qemagtelaamteki kenirraarluki.",
        "translation": "We only gathered a lot of those because we would store them after cooking them."
    },
    "157": {
        "startTime": 1176.5,
        "endTime": 1187.2,
        "transcript": "Tua-i tau͡gaam allat tua-i cipluki cali pillerkait aturarkaunrilkumteki pisqevkenaki.",
        "translation": "However, they told us not to gather more than we needed if we weren't going to use them."
    },
    "158": {
        "startTime": 1190.8,
        "endTime": 1201.7,
        "transcript": "Okay, as for berries, he says much like what they had said…",
        "translation": "Okay, as for berries, he says much like what they had said…"
    },
    "159": {
        "startTime": 1202.0,
        "endTime": 1210.0,
        "transcript": "Maa-i-wa elitnaurvigmi Kass'artarrlainarmek elitnaurameng, iciw' nalluit-gguq amlleret.",
        "translation": "Because they're only learning Western things in school, you know, they don't know a lot."
    },
    "160": {
        "startTime": 1210.3,
        "endTime": 1223.0,
        "transcript": "So, Eliza is saying that, you know, there was just so very much that we can learn of our culture, the ways.",
        "translation": "So, Eliza is saying that, you know, there was just so very much that we can learn of our culture, the ways."
    },
    "161": {
        "startTime": 1224.5,
        "endTime": 1235.3,
        "transcript": "Even just the plants by themselves, if you look at that leaving everything else, they're really just numerous",
        "translation": "Even just the plants by themselves, if you look at that leaving everything else, they're really just numerous"
    },
    "162": {
        "startTime": 1235.4,
        "endTime": 1243.0,
        "transcript": "That we can learn and our children can learn, but they're not learning because they're not taught in schools.",
        "translation": "That we can learn and our children can learn, but they're not learning because they're not taught in schools."
    },
    "163": {
        "startTime": 1245.0,
        "endTime": 1252.0,
        "transcript": "Ilumun amlleqapiartuq nallukengarci, elpet-llu-w' nallukengaten aperyaraungraata.",
        "translation": "There is truly a lot that youpl don't know, and things you don't know including words."
    },
    "164": {
        "startTime": 1252.5,
        "endTime": 1255.0,
        "transcript": "Nallukengaci amlleqapiartut.",
        "translation": "There is so much that youpl don't know."
    },
    "165": {
        "startTime": 1255.4,
        "endTime": 1262.5,
        "transcript": "Cali-llu waniwa qanrumayaaqelriaci tamatumek. Cali ilii cali qanrutkumanrituq cali.",
        "translation": "And now, youpl have been talking about that. Some of it is still not talked about."
    },
    "166": {
        "startTime": 1263.5,
        "endTime": 1267.0,
        "transcript": "Tamaa-i tau͡gaam taringevkarluku piaput, piukut waniwa.",
        "translation": "But now, we are helping her understand."
    },
    "167": {
        "startTime": 1267.1,
        "endTime": 1269.0,
        "transcript": "Au͡gkut-llu-w' tua-i ava-i…",
        "translation": "And what was said just now…"
    },
    "168": {
        "startTime": 1274.0,
        "endTime": 1275.0,
        "transcript": "Quyana.",
        "translation": "Thank you."
    },
    "169": {
        "startTime": 1279.0,
        "endTime": 1280.0,
        "transcript": "Ilaput.",
        "translation": "Our companions."
    },
    "170": {
        "startTime": 1280.7,
        "endTime": 1287.0,
        "transcript": "Au͡gkut nangneqliqluki piqataranka neqkaput makut plant-at.",
        "translation": "I am going to end with those plants that we eat."
    },
    "171": {
        "startTime": 1287.2,
        "endTime": 1293.5,
        "transcript": "Cali avelngaat ikayularaitkut neqkamteńek ayuqenrilngurnek.",
        "translation": "Voles also help us with different foods that we eat."
    },
    "172": {
        "startTime": 1294.5,
        "endTime": 1303.5,
        "transcript": "Aterpaggluki-llu pingailketen tayima ayuqenrilata atrit.",
        "translation": "And you probably won't say them by name because they have different names."
    },
    "173": {
        "startTime": 1303.9,
        "endTime": 1315.0,
        "transcript": "Tua-i avelngaat cali nertukemteńek uksuarmi neqkarcilartut caqussayuteng tua-i tamakut imirluki muirluki.",
        "translation": "Voles also gather food that we eat in the fall filling up their caches full."
    },
    "174": {
        "startTime": 1315.5,
        "endTime": 1318.9,
        "transcript": "Wangkuta-ll' yuarluki tua-i nunam iluanek camaken.",
        "translation": "And we look for them under the ground."
    },
    "175": {
        "startTime": 1319.0,
        "endTime": 1327.5,
        "transcript": "Tua-i tamakut cali nertukput avelngaat quyurtelarait ayuqenrilnguut atellgutkevkenateng.",
        "translation": "Voles also gather those various things that we eat with different names."
    },
    "176": {
        "startTime": 1327.6,
        "endTime": 1338.7,
        "transcript": "Un'gani-llu cali tua-i tauna coast tua-i cali tamakut avelngaat piit ayuqenrilnguut cali nertukput quyurtetuluki ellaita.",
        "translation": "And down on the coast, those voles also gather different things that we eat."
    },
    "177": {
        "startTime": 1338.8,
        "endTime": 1344.0,
        "transcript": "Tua-i tau͡gaam wangkuta neqairluki teguigaqluki tua-i-w' assiata.",
        "translation": "But we take their food from them because they're good."
    },
    "178": {
        "startTime": 1344.5,
        "endTime": 1346.8,
        "transcript": "Akutaqluki atutuluki.",
        "translation": "We use them for Yup'ik ice cream."
    },
    "179": {
        "startTime": 1347.0,
        "endTime": 1350.0,
        "transcript": "Tua-i nangneqliqluku au͡gna piaqa.",
        "translation": "That's the last thing I'm [saying]."
    }
};